import { render, staticRenderFns } from "./AddPurchaseFiles.vue?vue&type=template&id=a7ccedfc&scoped=true"
import script from "./AddPurchaseFiles.vue?vue&type=script&lang=js"
export * from "./AddPurchaseFiles.vue?vue&type=script&lang=js"
import style0 from "./AddPurchaseFiles.vue?vue&type=style&index=0&id=a7ccedfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ccedfc",
  null
  
)

export default component.exports